import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  HEARINGSTATUS_CREATED,
  HEARINGSTATUS_DRAFT,
  HEARINGSTATUS_AWAITING_STARTDATE,
  HEARINGSTATUS_ACTIVE,
  HEARINGSTATUS_AWAITING_CONCLUSION,
  HEARINGSTATUS_CONCLUDED,
} from '../constants/api';

const HearingStatusTag = ({ status }) => {
  const { t: translator } = useTranslation();

  const renderTag = () => {
    switch (status) {
      case HEARINGSTATUS_CREATED:
        return (
          <div className="status-tag-child status-tag-child__created">
            {translator('hearingStatus.created')}
          </div>
        );
      case HEARINGSTATUS_DRAFT:
        return (
          <div className="status-tag-child status-tag-child__draft">
            {translator('hearingStatus.draft')}
          </div>
        );
      case HEARINGSTATUS_AWAITING_STARTDATE:
        return (
          <div className="status-tag-child status-tag-child__awaiting-startdate">
            {translator('hearingStatus.awaitingStartdate')}
          </div>
        );
      case HEARINGSTATUS_ACTIVE:
        return (
          <div className="status-tag-child status-tag-child__active">
            {translator('hearingStatus.active')}
          </div>
        );
      case HEARINGSTATUS_AWAITING_CONCLUSION:
        return (
          <div className="status-tag-child status-tag-child__awaiting-conclusion">
            {translator('hearingStatus.awaitingConclusion')}
          </div>
        );
      case HEARINGSTATUS_CONCLUDED:
        return (
          <div className="status-tag-child status-tag-child__ended">
            {translator('hearingStatus.concluded')}
          </div>
        );
      default:
        return null;
    }
  };

  return <div className="status-tag">{renderTag()}</div>;
};

export { HearingStatusTag };
